export function openWindow(url: string, title: string, size: { width: number; height: number }) {
  // Fix dual-screen position (works on most browsers / monitors)
  const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

  const width = window.innerWidth
    ? window.innerWidth
    : document.documentElement.clientWidth
      ? document.documentElement.clientWidth
      : screen.width;

  const height = window.innerHeight
    ? window.innerHeight
    : document.documentElement.clientHeight
      ? document.documentElement.clientHeight
      : screen.height;

  const left = width / 2 - size.width / 2 + dualScreenLeft;
  const top = height / 2 - size.height / 2 + dualScreenTop;

  const popup = window.open(
    "",
    title,
    `width=${size.width},height=${size.height},top=${top},left=${left}`,
  );

  // Ideally we'd use `noopener` or `noreferrer` but Safari ignores the window dimensions when either of those features are used.
  //
  // To get around this quirk, first detach from the parent window manually then update the URL.
  if (popup) {
    popup.opener = null;
    popup.location = url;
  }

  return popup;
}
